// extracted by mini-css-extract-plugin
module.exports = {"center":"ErrorModal_center__jknsL"};